// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"181":"a7b1d688","343":"786c48c8","517":"be9cde34","555":"91d26e60","788":"774d3644"}[chunkId] + ".chunk.js";
};